import React from "react";

interface SectionProps {
  id?: string;
  title: string;
  icon?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

export const Section: React.FC<SectionProps> = ({
  id,
  title,
  icon,
  children,
  className = "",
}) => (
  <section id={id} className={`scroll-mt-20 ${className}`}>
    <div className="mx-auto max-w-6xl px-4 md:px-6 lg:px-8">
      <div className="mb-6 flex items-center gap-3">
        <div className="rounded-xl border border-black/10 bg-black/5 p-2 shadow-sm backdrop-blur supports-[backdrop-filter]:bg-black/5 dark:border-white/10 dark:bg-white/5">
          {icon}
        </div>
        <h2 className="text-xl font-semibold tracking-tight md:text-2xl">
          {title}
        </h2>
      </div>
      {children}
    </div>
  </section>
);
